import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  Testability,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Event,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { NotFoundRouteConfig } from '@freelancer/404';
import { LinkTags } from '@freelancer/link-tags';
import { TimeUtils } from '@freelancer/time-utils';
import { Tracking } from '@freelancer/tracking';
import { filter } from 'rxjs/operators';
import { SITE_NAME } from './app.config';

// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
// Application-wide code should be avoided as much as possible; does your code
// needs:
// - to be loaded on ALL logged-in pages?
// - AND to be loaded on ALL logged-out pages?
// - AND to be loaded on the Admin?
// - ...
// Probably not.
@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <fl-tracking *ngIf="isBrowser"></fl-tracking>
    <fl-location></fl-location>
    <fl-modal></fl-modal>
  `,
})
export class AppComponent implements OnInit {
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(SITE_NAME) private siteName: string,
    private timeUtils: TimeUtils,
    private testability: Testability,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tracking: Tracking,
    private title: Title,
    private linksTags: LinkTags,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.router.events.subscribe(event => {
      // track page views
      if (event instanceof NavigationEnd) {
        this.tracking.trackPageView(
          getRecursiveRouteData(this.activatedRoute.snapshot).is404,
        );
      }
      // reset to default title on navigation.
      if (event instanceof NavigationStart) {
        this.title.setTitle(this.siteName);
      }
    });
  }

  ngOnInit() {
    this.linksTags.setSiteWideLinks();
    // FIXME: detect Protractor env better
    if (this.isBrowser && window.location.host === 'localhost:5000') {
      this.router.events
        .pipe(filter((event: Event) => event instanceof NavigationEnd))
        .subscribe(() => {
          let pendingTasks: any;
          let timerDone = false;
          let isStable = false;
          const timeoutId = this.timeUtils.setTimeout(() => {
            console.warn(
              'Pending tasks blocking zone stabilization:',
              pendingTasks,
            );
            timerDone = true;
          }, 5000);

          this.testability.whenStable(
            (e: any) => {
              console.log('zone stable');
              isStable = true;
              clearTimeout(timeoutId);
            },
            0,
            (e: any) => {
              pendingTasks = e;
              if (timerDone && !isStable) {
                console.warn(
                  'Pending tasks blocking zone stabilization:',
                  pendingTasks,
                );
              }
            },
          );
        });
    }
  }
}

/**
 * get config from nested child routes
 * TODO: we should enable paramsInheritanceStrategy instead
 */
export function getRecursiveRouteData(
  snapshot: ActivatedRouteSnapshot,
): NotFoundRouteConfig {
  let { data } = snapshot;
  snapshot.children.forEach(child => {
    data = { ...data, ...getRecursiveRouteData(child) };
  });
  return data;
}
